export default __webpack_public_path__ + "static/pho-a64d6930e509cda04abc896ac14b6232.jpg";